import React, { useEffect, useRef, useState } from 'react'
import { getAnalytics } from './client.cjs'
import './consent.css'

export default function AnalyticsConsent() {
  const [visible, setVisible] = useState(false)
  const panelRef = useRef(null)
  const triggerRef = useRef(null)
  useEffect(() => {
    const analytics = getAnalytics()
    setVisible(analytics.available() && !analytics.getConsent())
    const close = () => setVisible(false)
    const open = () => {
      triggerRef.current = document.activeElement
      setVisible(true)
    }
    window.addEventListener('acs:analytics-consent', close)
    window.addEventListener('acs:open-cookie-settings', open)
    return () => {
      window.removeEventListener('acs:analytics-consent', close)
      window.removeEventListener('acs:open-cookie-settings', open)
    }
  }, [])
  useEffect(() => {
    if (visible && triggerRef.current) panelRef.current?.focus()
  }, [visible])
  const choose = value => {
    getAnalytics().setConsent(value)
    setVisible(false)
    triggerRef.current?.focus()
    triggerRef.current = null
  }
  return <>
    {visible && <section ref={panelRef} tabIndex={-1} className='acs-cookie-panel' role='region' aria-label='Analitik çerez tercihleri'>
      <strong>Gizlilik tercihleriniz</strong>
      <p>İzninizle, site kullanımını anlamak için Google Analytics çerezleri kullanıyoruz. Reddetmeniz giriş ve kayıt işlemlerinizi etkilemez. <a href='/privacy'>Gizlilik ve KVKK</a></p>
      <div>
        <button onClick={() => choose('denied')}>Reddet</button>
        <button onClick={() => choose('granted')}>Analitiğe izin ver</button>
      </div>
    </section>}
  </>
}
